export const dummyStoreLocations = [
  {
    location_id: '0197ee7f-ac8f-779a-a7af-b462cbf315df',
    location_name: 'Dummy SPARK',
    location_address:
      'UG - 57,58, Jl. Gerbang Pemuda No.3, Gelora, Kecamatan Tanah Abang, Jakarta, Daerah Khusus Ibukota Jakarta 10270',
    is_default: false,
    is_pickup_in_store: true,
    pinpoint: {
      lat: -6.212349,
      lng: 106.8053944,
    },
    _distance: 1.2,
    available_stock: 10,
    location_operations: [
      {
        days: 'Monday',
        start_time: '09:00:00',
        end_time: '17:00:00',
        is_active: true,
      },
      {
        days: 'Tuesday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: true,
      },
      {
        days: 'Wednesday',
        start_time: '09:30:00',
        end_time: '19:30:00',
        is_active: true,
      },
      {
        days: 'Thursday',
        start_time: '09:00:00',
        end_time: '20:00:00',
        is_active: true,
      },
      {
        days: 'Friday',
        start_time: '08:00:00',
        end_time: '16:00:00',
        is_active: true,
      },
      {
        days: 'Saturday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
      {
        days: 'Sunday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
    ],
  },
  {
    location_id: '1f4d5b88-9c5e-4e1b-9b82-3e2e27c8bd9a',
    location_name: 'Dummy Kota Kasablanka',
    location_address:
      'Mall Kota Kasablanka Lt. LG, Jl. Casablanca Raya Kav. 88, Menteng Dalam, Jakarta Selatan',
    is_default: false,
    is_pickup_in_store: true,
    pinpoint: {
      lat: -6.229728,
      lng: 106.846778,
    },
    _distance: 4.7,
    available_stock: 0,
    location_operations: [
      {
        days: 'Monday',
        start_time: '09:00:00',
        end_time: '17:00:00',
        is_active: true,
      },
      {
        days: 'Tuesday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: true,
      },
      {
        days: 'Wednesday',
        start_time: '09:30:00',
        end_time: '19:30:00',
        is_active: true,
      },
      {
        days: 'Thursday',
        start_time: '09:00:00',
        end_time: '20:00:00',
        is_active: true,
      },
      {
        days: 'Friday',
        start_time: '08:00:00',
        end_time: '16:00:00',
        is_active: true,
      },
      {
        days: 'Saturday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
      {
        days: 'Sunday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
    ],
  },
  {
    location_id: 'cbd22380-b3b9-4f6d-9484-44b2f801d798',
    location_name: 'Dummy Grand Indonesia',
    location_address: 'Jl. M.H. Thamrin No.1, Gondangdia, Menteng, Jakarta Pusat',
    is_default: true,
    is_pickup_in_store: true,
    pinpoint: {
      lat: -6.195123,
      lng: 106.821799,
    },
    _distance: 2.1,
    available_stock: 0,
    location_operations: [
      {
        days: 'Monday',
        start_time: '09:00:00',
        end_time: '17:00:00',
        is_active: true,
      },
      {
        days: 'Tuesday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: true,
      },
      {
        days: 'Wednesday',
        start_time: '09:30:00',
        end_time: '19:30:00',
        is_active: true,
      },
      {
        days: 'Thursday',
        start_time: '09:00:00',
        end_time: '20:00:00',
        is_active: true,
      },
      {
        days: 'Friday',
        start_time: '08:00:00',
        end_time: '16:00:00',
        is_active: true,
      },
      {
        days: 'Saturday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
      {
        days: 'Sunday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
    ],
  },
  {
    location_id: 'f9a4cf02-d474-4174-85c7-3cfdccfa1d66',
    location_name: 'Dummy PIK Avenue',
    location_address: 'Jl. Pantai Indah Kapuk Blvd, Kamal Muara, Penjaringan, Jakarta Utara',
    is_default: false,
    is_pickup_in_store: true,
    pinpoint: {
      lat: -6.118167,
      lng: 106.743776,
    },
    _distance: 12.8,
    available_stock: 100,
    location_operations: [
      {
        days: 'Monday',
        start_time: '09:00:00',
        end_time: '17:00:00',
        is_active: true,
      },
      {
        days: 'Tuesday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: true,
      },
      {
        days: 'Wednesday',
        start_time: '09:30:00',
        end_time: '19:30:00',
        is_active: true,
      },
      {
        days: 'Thursday',
        start_time: '09:00:00',
        end_time: '20:00:00',
        is_active: true,
      },
      {
        days: 'Friday',
        start_time: '08:00:00',
        end_time: '16:00:00',
        is_active: true,
      },
      {
        days: 'Saturday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
      {
        days: 'Sunday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
    ],
  },
  {
    location_id: 'a59b3cf6-3d4b-4ea1-b6cf-3a51f5428bb5',
    location_name: 'Dummy Pondok Indah Mall',
    location_address:
      'Pondok Indah Mall 2, Jl. Metro Pondok Indah, Kebayoran Lama, Jakarta Selatan',
    is_default: false,
    is_pickup_in_store: true,
    pinpoint: {
      lat: -6.260788,
      lng: 106.779132,
    },
    _distance: 8.3,
    available_stock: 100,
    location_operations: [
      {
        days: 'Monday',
        start_time: '09:00:00',
        end_time: '17:00:00',
        is_active: true,
      },
      {
        days: 'Tuesday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: true,
      },
      {
        days: 'Wednesday',
        start_time: '09:30:00',
        end_time: '19:30:00',
        is_active: true,
      },
      {
        days: 'Thursday',
        start_time: '09:00:00',
        end_time: '20:00:00',
        is_active: true,
      },
      {
        days: 'Friday',
        start_time: '08:00:00',
        end_time: '16:00:00',
        is_active: true,
      },
      {
        days: 'Saturday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
      {
        days: 'Sunday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
    ],
  },
  {
    location_id: '9f4c82ee-04df-4f56-bbf9-2cd99919e9e9',
    location_name: 'Dummy Plaza Senayan',
    location_address: 'Jl. Asia Afrika No.8, Gelora, Tanah Abang, Jakarta Pusat',
    is_default: false,
    is_pickup_in_store: true,
    pinpoint: {
      lat: -6.225273,
      lng: 106.799133,
    },
    _distance: 2.4,
    available_stock: 100,
    location_operations: [
      {
        days: 'Monday',
        start_time: '09:00:00',
        end_time: '17:00:00',
        is_active: true,
      },
      {
        days: 'Tuesday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: true,
      },
      {
        days: 'Wednesday',
        start_time: '09:30:00',
        end_time: '19:30:00',
        is_active: true,
      },
      {
        days: 'Thursday',
        start_time: '09:00:00',
        end_time: '20:00:00',
        is_active: true,
      },
      {
        days: 'Friday',
        start_time: '08:00:00',
        end_time: '16:00:00',
        is_active: true,
      },
      {
        days: 'Saturday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
      {
        days: 'Sunday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
    ],
  },
  {
    location_id: '7c6f1e3c-c6c1-486c-bcc6-2a7c46bc1e15',
    location_name: 'Dummy Lippo Mall Kemang',
    location_address: 'Jl. Pangeran Antasari No.36, Kemang, Jakarta Selatan',
    is_default: false,
    is_pickup_in_store: true,
    pinpoint: {
      lat: -6.260586,
      lng: 106.812403,
    },
    _distance: 6.9,
    available_stock: 100,
    location_operations: [
      {
        days: 'Monday',
        start_time: '09:00:00',
        end_time: '17:00:00',
        is_active: true,
      },
      {
        days: 'Tuesday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: true,
      },
      {
        days: 'Wednesday',
        start_time: '09:30:00',
        end_time: '19:30:00',
        is_active: true,
      },
      {
        days: 'Thursday',
        start_time: '09:00:00',
        end_time: '20:00:00',
        is_active: true,
      },
      {
        days: 'Friday',
        start_time: '08:00:00',
        end_time: '16:00:00',
        is_active: true,
      },
      {
        days: 'Saturday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
      {
        days: 'Sunday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
    ],
  },
  {
    location_id: '8aa2b709-cc6e-4ec4-9426-72b69c3fe6cf',
    location_name: 'Dummy Mall Taman Anggrek',
    location_address: 'Jl. Letjen S. Parman Kav. 21, Tanjung Duren, Jakarta Barat',
    is_default: false,
    is_pickup_in_store: true,
    pinpoint: {
      lat: -6.177681,
      lng: 106.790742,
    },
    _distance: 4.2,
    available_stock: 100,
    location_operations: [
      {
        days: 'Monday',
        start_time: '09:00:00',
        end_time: '17:00:00',
        is_active: true,
      },
      {
        days: 'Tuesday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: true,
      },
      {
        days: 'Wednesday',
        start_time: '09:30:00',
        end_time: '19:30:00',
        is_active: true,
      },
      {
        days: 'Thursday',
        start_time: '09:00:00',
        end_time: '20:00:00',
        is_active: true,
      },
      {
        days: 'Friday',
        start_time: '08:00:00',
        end_time: '16:00:00',
        is_active: true,
      },
      {
        days: 'Saturday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
      {
        days: 'Sunday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
    ],
  },
  {
    location_id: '5de9a4aa-95cc-4f15-996a-90b89d7c0a85',
    location_name: 'Dummy Senayan City',
    location_address: 'Jl. Asia Afrika Lot. 19, Gelora, Tanah Abang, Jakarta Pusat',
    is_default: false,
    is_pickup_in_store: true,
    pinpoint: {
      lat: -6.22595,
      lng: 106.799553,
    },
    _distance: 2.6,
    available_stock: 100,
    location_operations: [
      {
        days: 'Monday',
        start_time: '09:00:00',
        end_time: '17:00:00',
        is_active: true,
      },
      {
        days: 'Tuesday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: true,
      },
      {
        days: 'Wednesday',
        start_time: '09:30:00',
        end_time: '19:30:00',
        is_active: true,
      },
      {
        days: 'Thursday',
        start_time: '09:00:00',
        end_time: '20:00:00',
        is_active: true,
      },
      {
        days: 'Friday',
        start_time: '08:00:00',
        end_time: '16:00:00',
        is_active: true,
      },
      {
        days: 'Saturday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
      {
        days: 'Sunday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
    ],
  },
  {
    location_id: 'e18b9f5e-dc61-4b89-8037-ef46990fcdab',
    location_name: 'Dummy AEON Mall BSD',
    location_address: 'Jl. BSD Raya Utama, Pagedangan, Tangerang Selatan',
    is_default: false,
    is_pickup_in_store: true,
    pinpoint: {
      lat: -6.304855,
      lng: 106.653377,
    },
    _distance: 24.5,
    available_stock: 100,
    location_operations: [
      {
        days: 'Monday',
        start_time: '09:00:00',
        end_time: '17:00:00',
        is_active: true,
      },
      {
        days: 'Tuesday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: true,
      },
      {
        days: 'Wednesday',
        start_time: '09:30:00',
        end_time: '19:30:00',
        is_active: true,
      },
      {
        days: 'Thursday',
        start_time: '09:00:00',
        end_time: '20:00:00',
        is_active: true,
      },
      {
        days: 'Friday',
        start_time: '08:00:00',
        end_time: '16:00:00',
        is_active: true,
      },
      {
        days: 'Saturday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
      {
        days: 'Sunday',
        start_time: '09:00:00',
        end_time: '18:00:00',
        is_active: false,
      },
    ],
  },
];
